import React from "react"

import colors from "../colors"

import { PageLayout } from "../components/layouts"
import SEO from "../components/seo"

import SingleColumnBlock from "../components/singleColumnBlock"

import {
  ContactForm,
  FormWrapper,
  RequestMoreInfo,
  RequestQuote,
} from "@components/Forms"

import {
  RequestMoreInfoButton,
  ContactUsTodayButton,
  DownloadProductBrochureButton,
} from "../components/buttons"

const iconProps = {
  size: "60px",
  color: colors.darkBlue,
}

const ContactUs = () => {
  return (
    <PageLayout>
      <SEO
        title="Contact Us | ArtVue Glass"
        ogDescription="Give us a call or fill out the form for Decorative Glass Information."
      />
      <SingleColumnBlock
        textPadded
        text={
          <div>
            <h1>
              Contact Us
            </h1>
            <p>
              Give us a call or fill out the form below for Decorative Glass Information.
            </p>
            <p>
              WE’RE AVAILABLE BY PHONE <a href="tel:19413781762">1-941-378-1762</a>
            </p>
            <ContactForm />
          </div>
        }
      />
    </PageLayout>
  )
}

export default ContactUs
